import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DefaultBranchService {
  private defaultBranchSet = new BehaviorSubject<boolean>(false);
  defaultBranch$: Observable<boolean> = this.defaultBranchSet.asObservable();

  notifyDefaultBranchSet(): void {
    this.defaultBranchSet.next(true);
  }
}
